import { Localized } from '~/i18n';
import ScalekitLogo from '~/assets/scalekit-logo-dark.svg';
import { mergeProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import Link from '../Link';

type ScalekitWatermarkProps = {
  class?: string;
};
mergeProps;

export default function ScalekitWatermark(props: ScalekitWatermarkProps) {
  const merged = mergeProps({}, props);
  return (
    <div
      class={twMerge(
        'flex items-center justify-center gap-1 bg-bg-subtle w-full p-2',
        merged.class
      )}
    >
      <span class="text-xs text-fg-subtle">
        <Localized translationKey="commons.scalekit_watermark.text" />
      </span>
      <Link
        href={'https://www.scalekit.com/'}
        target="_blank"
      >
        <img
          class={`w-[50px]`}
          src={ScalekitLogo}
          alt={'Scalekit'}
        />
      </Link>
    </div>
  );
}
